import { BASE_BUTTON_SIZE, BASE_BUTTON_VARIANT } from '../VBaseButton/constant';

export const ICON_BUTTON_SIZE = {
  /** @deprecated */
  EXTRA_SMALL: 'extraSmall',
  /** @deprecated */
  SMALL: 'small',
  /** @deprecated */
  MEDIUM: 'medium',

  ...BASE_BUTTON_SIZE,
} as const;

export const ICON_BUTTON_VARIANT = {
  ...BASE_BUTTON_VARIANT,

  ROUND_PRIMARY: 'roundPrimary',
  ROUND_SECONDARY: 'roundSecondary',
  ROUND_DANGER: 'roundDanger',
  ROUND_CANCEL: 'roundCancel',
} as const;
